import { HTTP_STATUS } from 'components/constants';
import { setLoginDetails } from '../redux/features/auth';
import store from '../redux/store';
import clearLocalStorage from './clear-local-storage';

let refreshPromise: Promise<any> | null = null;

export async function validateTokenExpiryAndGetToken(
  authData: {
    exp: number;
    email: string;
    token: {
      idToken: string;
      accessToken: string;
      refreshToken: string;
    };
  },
  request: any,
) {
  const { idToken, accessToken, refreshToken } = authData.token;
  const currentExpiry =
    authData && authData?.exp ? (authData?.exp - 30) * 1000 : 0;
  const currentTimeStamp = Date.now();

  if (!refreshToken) return false;

  if (
    currentExpiry < currentTimeStamp ||
    !accessToken ||
    isNaN(currentExpiry)
  ) {
    if (!refreshPromise) {
      refreshPromise = (async () => {
        try {
          let api = request('POST');
          let newData = await api(`auth/refreshToken`, {
            username: authData?.email,
            refreshToken,
          });

          if ([HTTP_STATUS.OK, HTTP_STATUS.CREATED].includes(newData?.statusCode)) {
            store.dispatch(setLoginDetails(newData?.data));
            return newData?.data?.token?.idToken;
          } else {
            setTimeout(() => {
              clearLocalStorage();
              window.location.reload();
            }, 1500);
            return false;
          }
        } catch (err) {
          clearLocalStorage();
          setTimeout(() => {
              clearLocalStorage();
              window.location.reload();
            }, 1500);
          return false;
        } finally {
          refreshPromise = null;
        }
      })();
    }

    return await refreshPromise;
  }

  return idToken;
}

